import {css} from 'lit'; export default css`.clear-search-history-item{opacity:0}.search-history-item:focus .clear-search-history-item,.search-history-item:hover .clear-search-history-item{opacity:1}`;
    